export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return function () {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export interface EquityCurveOptions {
  seed?: number;
  steps?: number;
  drift?: number;
  vol?: number;
  start?: number;
}

export function equityCurve({
  seed = 1,
  steps = 252,
  drift = 0.0006,
  vol = 0.012,
  start = 100,
}: EquityCurveOptions = {}): number[] {
  const rand = mulberry32(seed);
  const out: number[] = [start];
  for (let i = 1; i < steps; i++) {
    const z = boxMuller(rand);
    const prev = out[i - 1] ?? start;
    const next = prev * Math.exp(drift - 0.5 * vol * vol + vol * z);
    out.push(next);
  }
  return out;
}

function boxMuller(rand: () => number): number {
  let u = 0;
  let v = 0;
  while (u === 0) u = rand();
  while (v === 0) v = rand();
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}
